import React, {Fragment, useCallback} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import CubeComponentListItem from "../../../../../components/cube-component-list/item";
import {isForcedChecked} from "./utils";

const mapStateToProps = state => {
    return {
        aliasCols: state.scenes.mappingHandler.datasetBuilder.unionModalProps.aliasCols,
    }
};

const UnionColumnComponentList = ({
                                      labelKey,
                                      checkboxDisabled,
                                      onChange,
                                      aliasCols,
                                      value
                                  }) => {
    const setChecked = useCallback((componentsListKey, code, checked) => {
        if (!onChange) {
            return;
        }
        const newValue = {
            ...value,
            [componentsListKey]: value[componentsListKey].map(comp =>
                comp.Code === code
                    ? ({
                        ...comp,
                        checked: checked
                    })
                    : comp
            )
        }
        onChange(newValue);
    }, [onChange, value]);

    if (!value) {
        return null;
    }

    return (
        <Fragment>
            {(value.dimensions || [])
                .map(dim =>
                    <CubeComponentListItem
                        key={dim.Code}
                        label={dim[labelKey || 'Code']}
                        disabled={dim.disabled || checkboxDisabled || isForcedChecked(aliasCols, dim.Code)}
                        isChecked={dim.checked || isForcedChecked(aliasCols, dim.Code)}
                        hasCheckbox
                        onChange={e => setChecked('dimensions', dim.Code, e.target.checked)}
                        leaveNameUnchanged
                    />)
            }
        </Fragment>
    );

}

export default compose(translate(), connect(mapStateToProps))(UnionColumnComponentList);
